module.exports = __webpack_public_path__ + "static/media/token.4f6b49c7.png";